<div class="video-modal">
  <div class="modal-header">
    <div>{{ videoTitle }}</div>
    <button type="button" class="btn-close" aria-label="Close" (click)="closePopup()"></button>
  </div>
  <div class="modal-body p-1">
    <video #videoPlayer id="my-video"
      class="video-js vjs-default-skin"
      height="460"
      *ngIf="isVideoAvailable">
      <source src="{{ VideoInfo.convertedUrl }}" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
    <div style="width: 100%;height: 100%;min-height: 200px;" class="text-center" *ngIf="!isVideoAvailable">
      <span class="fa-stack fa-2x">
        <i class="fa fa-film fa-stack-2x" style="color: #a0a0a0"></i>
        <i class="fa fa-cog fa-spin fa-stack-1x " style="color: #000;" *ngIf="!VideoInfo.hasError"></i>
        <i class="fa fa-exclamation-circle fa-stack-1x text-danger" *ngIf="VideoInfo.hasError"></i>
      </span>
      <br /><br />
      {{ conversionMessage }}
    </div>
  </div>
</div>
